import React from "react";
import PropTypes from "prop-types";
import { Item, Header } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { getParamPairs, getParamString } from "../../../utils/utils";

const MiscResultsGroup = ({ items, header }) => {
  return (
    <div style={{ textAlign: "center", marginTop: "1rem" }}>
      {header && (
        <Header
          content={header}
          as="h1"
          style={{ margin: "1rem 0 0.5rem 0", color: "whitesmoke" }}
        />
      )}
      <Item.Group
        style={{ display: "flex", flexWrap: "wrap", textAlign: "center" }}
      >
        {items.map(({ id, name, images, uri }) => (
          <Item
            as={Link}
            to={{
              search: getParamString({
                ...getParamPairs(window.location.href),
                collection: uri,
              }),
            }}
            key={id}
            style={{
              maxWidth: "50vw",
              width: "256px",
              marginTop: "0.5rem",
              marginBottom: "0.5rem",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Item.Image
              src={
                (images[1] && images[1].url) ||
                (images[0] && images[0].url) ||
                "/vinyl-record-144x144.png"
              }
              style={{ padding: "0.25rem", margin: "0" }}
            />
            <Item.Content
              style={{
                paddingTop: "0.25rem",
                paddingBottom: "0.25rem",
                display: "flex",
                flexDirection: "column",
                justifyContent: "end",
              }}
            >
              <Item.Header style={{ color: "whitesmoke" }}>{name}</Item.Header>
            </Item.Content>
          </Item>
        ))}
      </Item.Group>
    </div>
  );
};

MiscResultsGroup.propTypes = {
  items: PropTypes.array.isRequired,
  header: PropTypes.string,
};
MiscResultsGroup.defaultProps = {
  items: [],
  header: "",
};

export default MiscResultsGroup;
